import { ref, watch, computed } from "@vue/composition-api";
import store from "@/store";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default function CompensatoryOffApplicationList() {
    // Use toast
    const toast = useToast();

    const refUserListTable = ref(null);

    // Table Handlers
    const tableColumns = [
        { key: "select", sortable: false, label: "Select" },
        { key: "user.name", sortable: true, label: "Employee Name" },
        { key: "dates", sortable: true, label: "Dates" },
        { key: "duration", sortable: false, label: "Day Duration" },
        { key: "status", sortable: true, label: "Status" },
        { key: "action" }
    ];
    const perPage = ref(10);
    const totalCompensatoryOffApplicationList = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);
    const statusFilter = ref(null);
    const compensatoryOffApplicationsMetaData = ref([]);
    const compensatoryOffApplicationStatusOption = ref([]);
    const createdByFilter = ref(null);
    const managerFilter = ref(null);

    const dataMeta = computed(() => {
        const localItemsCount = refUserListTable.value
            ? refUserListTable.value.localItems.length
            : 0;
        return {
            from:
                perPage.value * (currentPage.value - 1) +
                (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalCompensatoryOffApplicationList.value
        };
    });

    const refetchData = () => {
        refUserListTable.value.refresh();
    };

    watch(
        [currentPage, perPage, searchQuery, statusFilter,managerFilter, createdByFilter],
        () => {
            refetchData();
        }
    );

    const fetchCompensatoryOffApplicationList = (ctx, callback) => {
        store
            .dispatch(
                "app-compensatory-off-applications/fetchCompensatoryOffApplications",
                {
                    q: searchQuery.value,
                    perPage: perPage.value,
                    page: currentPage.value,
                    sortBy: sortBy.value,
                    sortDesc: isSortDirDesc.value,
                    status: statusFilter.value,
                    createdBy: createdByFilter.value,
                    manager: managerFilter.value,
                }
            )
            .then(response => {
                const compensatory_off_application = response.data.data;
                const { total } = response.data.meta;
                compensatoryOffApplicationStatusOption.value =
                    response.data.status;

                callback(compensatory_off_application);
                totalCompensatoryOffApplicationList.value = total;
                compensatoryOffApplicationsMetaData.value = compensatory_off_application;
            })
            .catch(error => {
                console.error(error);
                // toast({
                //     component: ToastificationContent,
                //     props: {
                //         title: "Error fetching Compensatory Off Applications",
                //         icon: "AlertTriangleIcon",
                //         variant: "danger"
                //     }
                // });
                toast({
                    component: ToastificationContent,
                    props: {
                      title: `Error fetching Compensatory Off Applications`,
                      icon:'AlertTriangleIcon',
                      variant : 'danger',
                      hideClose: true,
                      
                    },
                      },
                      {
                    timeout : 3000,
                    position : 'bottom-center',
                    toastClassName:"error-info",
                    hideProgressBar : true,
                      })
            });
    };

    const resolveUserStatusVariant = status => {
        if (status == 0) return "warning";
        if (status == 1) return "success";
        if (status == 2) return "danger";
        return "primary";
    };

    return {
        fetchCompensatoryOffApplicationList,
        tableColumns,
        perPage,
        currentPage,
        totalCompensatoryOffApplicationList,
        compensatoryOffApplicationsMetaData,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refUserListTable,
        refetchData,
        statusFilter,
        resolveUserStatusVariant,
        compensatoryOffApplicationStatusOption,
        createdByFilter,
        managerFilter
    };
}
